import { Injectable } from '@angular/core';
import { HttpClient, } from '@angular/common/http';
import { Observable,  } from 'rxjs';
import { map, catchError,  } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { functionpermission } from './import-payment.model';

@Injectable({
  providedIn: 'root'
})
export class ImportService {
    constructor(private http: HttpClient, public errorService: ErrorService) { }


    getFilePermissions(paramsData: URLSearchParams): Observable<functionpermission> {
        let url = "api/functionpermisssion/getfunctionpermission?";
        return this.http.get<functionpermission>(url + paramsData, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

  
    getBatchFileTstring(params:URLSearchParams): Observable<any> {
        let url = "api/Import/GetEDI835String?";
        return this.http.get(url + params,{ observe: 'response',responseType: "text"},).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
        )
      }

         //==============================get employee permission==========================================//
         getpermission(paramsData: URLSearchParams): Observable<any> {
          let url = "api/FunctionPermission/getfunctionpermissionemployee?";
          return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
          )
        }


//=============================================== powerBI ==============================================\\\
        getpowerbiToken(): Observable<any> {
          let url = "api/PowerBI/GetAccessToken?"
          return this.http.get<any>(url, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
          );
        }

}